var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "", id: "app" } },
    [
      _c(
        "b-row",
        [_c("b-col", { attrs: { cols: "12" } }, [_c("Navigation")], 1)],
        1
      ),
      _c("router-view", { staticClass: "mt-2" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }